'use client';

import { useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { LoaderCircle } from 'lucide-react';
import { toast } from 'sonner';

import { Link } from '@/components/link';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { env } from '@/lib/env';
import { useRouter } from '@/lib/router';

export function LoginPage() {
  const router = useRouter();
  const [client] = useState(() => createClient(env.PUBLIC_SUPABASE_URL, env.PUBLIC_SUPABASE_ANON_KEY));
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      const response = await client.auth.signInWithPassword({
        email,
        password,
      });
      console.log('auth response', response);
    },
    onSuccess: () => {
      toast.success('Login successful');
      router.push('/');
    },
    onError: () => {
      toast.error('Login failed');
    },
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    mutate();
  };

  return (
    <form className='space-y-6' onSubmit={handleSubmit}>
      <div className='space-y-1'>
        <div className='text-2xl font-medium'>Welcome to Solea</div>
        <p className='text-sm text-gray-500'>Sign in to your account to continue</p>
      </div>

      {/* {error ? <AuthMessage type='error'>{error}</AuthMessage> : null} */}

      <div className='space-y-1'>
        <Label htmlFor='email'>Email</Label>
        <Input name='email' type='email' placeholder='Email' value={email} onChange={(e) => setEmail(e.target.value)} />
      </div>

      <div className='space-y-1'>
        <div className='flex items-center justify-between'>
          <Label htmlFor='password'>Password</Label>
          <Link
            href='/forgot-password'
            className='text-xs font-medium text-gray-700 hover:text-foreground hover:underline'
          >
            Forgot your password?
          </Link>
        </div>

        <Input
          name='password'
          type='password'
          placeholder='Password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      <Button type='submit' size='lg' disabled={isPending} block>
        {isPending && <LoaderCircle className='size-4 animate-spin' />}
        Sign in
      </Button>
    </form>
  );
}
